import {IMember} from "../screens/AccountMembership/_private/types/midView";
import {DefaultTheme} from "styled-components";
import {IMegaMenu} from "models/megaMenu";
//
declare module "styled-components" {
    export interface DefaultTheme {
        handleState?: () => void;
        protocol?: "http" | "https" | "wss" | "ws";
        host?: string;
        requestUri?: string;
        requestUriNoQs?: string;
        domain?: string;
        hostNoSubDomain?: string;
        isUserLocationCountryAllowed?: boolean;
        translations?: any;
        direction: "rtl" | "ltr";
        isLTR: boolean;
        isRTL: boolean;
        country?: string;
        cityId?: number;
        locale: "ar" | "en";
        otp?: string;
        otp_number?: string;
        isLoggedIn: boolean;
        isRegistered: boolean
        isMobile: boolean;
        isDesktop: boolean;
        megaMenu?: IMegaMenu;
        isSplashScreenHiding: boolean;
        device?: string;
        memberData?: IMember;
        isChangeCountryPage?: boolean;
        showTopBanner?: boolean;
        enable3rdParty?: boolean;
        enableViber?: boolean;
        credentials?: { [key: string]: string };
        // updateThemeMemberData: (data: IMember) => void,
        LoginMember?: (
            state: boolean,
            redirect?: string,
            dialogType?: string,
            redirectOnClose?: boolean,
            credential?: { [key: string]: string },
            ImmediateCb?: {},
            onContinueCb?: {}
        ) => void;
        redirectOnLogin?: string;
        redirectOnClose?: boolean;
        url: string;
        ipCountryCode?: string;
        ShowSnackbar?: (state: boolean, message?: string, type?: string) => void;
        currentTab?: string;
        updateCurrentTab?: (tab: string) => void;
        colors: {
            Black: string;
            BlackGray: string;
            DarkBlue: string;
            BlueTransparent: string;
            White: string;
            Blue: string;
            BlueDark2: string;
            LightBlue2: string;
            LightBlue3: string;
            LightBlue: string;
            BlueLight: string;
            BlueDark: string;
            BlueDark4: string;
            BlueDark1: string;
            NavyBlue: string;
            OrangeDark: string;
            Green: string;
            Greendark: string;
            LightGreen: string;
            GreenLight: string;
            GreenLight3: string;
            DarkGray: string;
            DarkGray1: string;
            DarkGray2: string;
            DarkGray3: string;
            DarkGray4: string;
            Gray: string;
            GrayLight: string;
            LightGray: string;
            GraySecondary: string;
            LightGraySecondary: string;
            Red: string;
            Warning: string;
            Tertiary: string;
            GrayFour: string;
            GrayFive: string;
            GraySix: string;
            GraySeven: string;
            GrayEight: string;
            GrayNine: string;
            GrayTen: string;
            GrayEleven: string;
            GrayTwelve: string;
            GrayThirteen: string;
            BlackishGray: string;
            WhitishGray: string;
            GrayLightTwo: string;
            GrayLightThree: string;
            GrayLightFour: string;
            LightBlueTwo: string;
            LightGray1: string;
            GreenTwo: string;
            GreenNew: string;
            BlackOne: string;
            BlackThree: string;
            Gray12: string;
            Gray13: string;
            Black2: string;
            Gray14: string;
            Gray88: string;
            Gray89: string;
            Gray15: string;
            Gray16: string;
            Black3: string;
            Orange2: string;
            Orange3: string;
            Black4: string;
            Black5: string;
            Gray17: string;
            Black6: string;
            Gray18: string;
            Gray19: string;
            Gray20: string;
            Gray21: string;
            Gray22: string;
            Gray25: string;
            Gray24: string;
            LightGreen2: string;
            DarkGreen: string;
            Gray23: string;
            Error: string;
            Black7: string;
            Gray26: string;
            Gray27: string;
            Gray28: string;
            Gray29: string;
            Gray30: string;
            Green1: string;
            failure: string;
            success: string;
            warning: string;
            Gray31: string;
            Gray32: string;
            Gray33: string;
            Gray34: string;
            Gray35: string;
            Invalid: string;
            Gray36: string;
            NavyBlue2: string;
            Gray37: string;
            Gray38: string;
            Gray39: string;
            Gray40: string;
            Blue1: string;
            BlueDarkBg: string;
            BlackishGray2: string;
            Gray41: string;
            Blue2: string;
            Gray42: string;
            Gray43: string;
            Blue3: string;
            Green2: string;
            Green3: string;
            Green4: string;
            Red1: string;
            Red2: string;
            Orange1: string;
            Gray44: string;
            Blue4: string;
            Gray45: string;
            Blue5: string;
            Gray46: string;
            Green5: string;
            Gray47: string;
            Gray48: string;
            Gray49: string;
            Blue6: string;
            GrayBlack: string;
            GrayBlack1: string;
            Blue7: string;
            Gray51: string;
            Gray52: string;
            Red5: string;
            Gray53: string;
            Blue8: string;
            Blue9: string;
            Gray54: string;
            Green6: string;
            Gray59: string;
            Gray60: string;
            BlackLight: string;
            Yellow: string;
            Yellow11: string;
            Gray57: string;
            Gray58: string;
            Green7: string;
            Gray50: string;
            Gray55: string;
            Gray56: string;
            White2: string;
            Red3: string;
            Red4: string;
            Blue10: string;
            Gray61: string;
            Gray62: string;
            Green8: string;
            Gray63: string;
            Gray64: string;
            Gray68: string;
            Blue12: string;
            LightPink: string;
            LightRed: string;
            Gray65: string;
            Gray66: string;
            Gray67: string;
            Blue11: string;
            Gray69: string;
            White3: string;
            facebook: string;
            twitter: string;
            Green9: string;
            Gray70: string;
            Gray71: string;
            Gray72: string;
            Gray74: string;
            Blue15: string;
            Green10: string;
            Blue16: string;
            Blue18: string;
            Blue19: string;
            Gray73: string;
            Blue17: string;
            LightBlue1: string;
            Green11: string;
            Black8: string;
            SeaGreen: string;
            Gray75: string;
            Gray76: string;
            Gray77: string;
            Gray78: string;
            Gray79: string;
            Blue20: string;
            Blue21A: string;
            Blue22: string;
            GrayLightFive: string;
            GrayLightSix: string;
            Yellow1: string;
            Red7: string;
            Red8: string;
            Blue23: string;
            Yellow2: string;
            Black1A: string;
            Blue24: string;
            Blue25: string;
            Blue26: string;
            GrayLight1: string;
            GrayLight2: string;
            GrayLightBorder: string;
            GrayLightBorder2: string;
            BackgroundBlue: string;
            GrayBackground: string;
            GrayIconFill: string;
            BlueIconFill: string;
            OrangeBackground: string;
            White4: string;
            White5: string;
            Orange4: string;
            Orange5: string;
            BorderGray: string;
            Gray80A: string;
            GrayBorder1: string;
            Bluebackground: string;
            Gray_79: string;
            InputGray: string;
            BackgroundGray1: string;
            SliderBackground: string;
            RedAsterisk: string;
            TableBackground: string;
            GrayBorder: string;
            GrayBorder2: string;
            GrayColor: string;
            Gray81: string;
            Green12: string;
            Gray80: string;
            GrayColor1: string;
            GrayInput: string;
            BlueFocus: string;
            Gray100A: string;
            DarkGray5: string;
            Graydark1: string;
            MuiBorderColor: string;
            BlueLight1: string;
            GrayDisabled: string;
            GrayLabel: string;
            GrayBackground4: string;
            LabelGray: string;
            DarkGray22: string;
            Green13: string;
            inputFieldGray: string;
            headingGray: string;
            Gray82: string;
            BorderGray2: string;
            Gray93: string;
            //OpenSooq colors-standard
            Grey: string;
            Orange: string;
            Offline: string;
            Premium: string;
            Shop: string;
            Bundles: string;
            Elas: string;
            Turbo: string;
            Credit: string;
            Bumpup: string;
            Gold: string;
            Silver: string;
            WABg: string;
            LightGrayBorder: string;
            GrayLight5: string;
            LightGray2: string;
            Blue27: string;
            Gray101A: string;
            Black10A: string;
            GraySubLabel: string;
            GrayDark2: string;
            BlueBorder: string;
            Black11A: string;
            Blue10A: string;
            Orange6A: string;
            NavyBlue5A: string;
            BlackA10: string;
            Gray90: string;
            Gray91: string;
            Gray92: string;
            babyBlue: string;
            Gray94: string;
            SkyBlue1: string;
            Black20A: string;
            yellow: string;
        };

        fonts: {
            HelveticaNeue: string;
            HelveticaNeueBold: string;
            HelveticaNeueSKY: string;
            HelveticaNeueW23forSKYBd: string;
            Helvetica: string;
            SFArabic: string;
        };
    }
}

const defaultTheme: DefaultTheme = {
    locale: "ar",
    direction: "rtl",
    isLTR: false,
    isRTL: true,
    isLoggedIn: false,
    isRegistered: false,
    isMobile: false,
    isDesktop: false,
    isSplashScreenHiding: false,
    isChangeCountryPage: false,
    showTopBanner: true,
    enable3rdParty: true,
    enableViber: false,
    credentials: {},
    url: "",
    // updateThemeMemberData: (data: IMember) => {},
    colors: {
        Black: "#000",
        BlackGray: "#7b7b7b",
        DarkBlue: "#4a5e72",
        BlueTransparent: "#d0eafd",
        White: "#fff",
        Blue: "#0179FF",
        BlueDark2: "#4463b1",
        LightBlue2: "#4e9edc",
        LightBlue3: "#1bd0f5",
        LightBlue: "#4091d228",
        BlueLight: "#4091d2",
        BlueDark: "#008dff",
        BlueDark1: "#2483c5",
        NavyBlue: "#0079FF",
        BlueDark4: "#002C50",
        OrangeDark: "#c9861a",
        Green: "#67AD5C",
        Greendark: "#3A9479",
        DarkGreen: "#3c792b",
        LightGreen2: "#cdeaca",
        LightGreen: "#25D366",
        GreenLight: "#87b821",
        GreenLight3: "#b6d8b1",
        DarkGray: "#57585A",
        DarkGray1: "#d8d8d8",
        DarkGray2: "#4f4f4f",
        DarkGray3: "#3c3938",
        DarkGray4: "#717171",
        Gray: "#ccc",
        GrayLight: "#F7F8F8",
        LightGray: "#F2F2F7",
        LightGray1: "#f3f2f7",
        GraySecondary: "#e6e6e6",
        LightGraySecondary: "#f4f4f4",
        Red: "#EA4035",
        Warning: "#FF9900",
        Tertiary: "#686868",
        GrayFour: "#a2a2a2",
        GrayFive: "#d2d2d2",
        GraySix: "#595959",
        GraySeven: "#666666",
        GrayEight: "#f0f0f0",
        GrayNine: "#a5a5a5",
        GrayTen: "#dfdfdf",
        GrayTwelve: "#b7b7b7",
        GrayThirteen: "#a9a9a9",
        BlackishGray: "#444",
        WhitishGray: "#ddd",
        GrayLightTwo: "#f6f6f6",
        GrayLightThree: "#e1e1e1",
        GrayLightFour: "#f2f2f2",
        LightBlueTwo: "#e1eef8",
        GreenTwo: "#82b741",
        GreenNew: "#00bf99",
        GrayEleven: "#f7f8f9",
        BlackOne: "#4a4a4a",
        BlackThree: "#707070",
        Gray12: "#e4e4e4",
        Gray13: "#555",
        Black2: "#dcdcdc",
        Gray14: "#474747",
        Gray88: "#ECF0F1",
        Gray89: "#dde5e9",
        Gray15: "#ebebeb",
        Gray16: "#e0e0e0",
        Black3: "#57585a",
        Orange2: "#ff9900",
        Orange3: "#ff6900",
        Black4: "#292f62",
        Black5: "#191919",
        Gray17: "#f1f1f1",
        Black6: "#939393",
        Gray18: "#2e2e2e",
        Gray19: "#f3f5f7",
        Gray20: "#6b6b6b",
        Gray21: "#333",
        Gray22: "#eeeff0",
        Gray23: "#999999",
        Error: "#d6523c",
        Gray25: "#f3f2f8",
        Gray24: "#b1b1b1",
        Black7: "#414653",
        Gray26: "#c1c2c6",
        Gray27: "#dbdadb",
        Gray28: "#bababa",
        Gray29: "#C1C2C3",
        Green1: "#0ED560",
        failure: "#D0021B",
        success: "#9BC53D",
        warning: "#F3BE12",
        Gray30: "#909090",
        Gray31: "#CDCDCD",
        Gray32: "#5B5E60",
        Gray33: "#535455",
        Gray34: "#DDDDDD",
        Gray35: "#7D7D7D",
        Invalid: "#E11100",
        Gray36: "#d8d9da",
        Blue2: "#2c97ec",
        Blue5: "#3392d8",
        NavyBlue2: "#85bee8",
        Gray39: "#cccdce",
        Gray40: "#e8e8e8",
        Gray38: "#f5f5f5",
        Gray37: "#eff1f2",
        Blue1: "#3b90d5",
        BlueDarkBg: "#3272b2",
        BlackishGray2: "#686b81",
        Gray41: "#eee",
        Blue4: "#1d71b9",
        Gray42: "#aeaeae",
        Gray43: "#7f7f7f",
        Blue3: "#067ed9",
        Green2: "#88b700",
        Green3: "#86ba37",
        Red1: "#ff5335",
        Red2: "#f45353",
        Orange1: "#f29c12",
        Gray44: "#ababab",
        Gray45: "#767676",
        Green4: "#009688",
        Gray46: "#DCDCDD",
        Gray47: "#f7f7f7",
        Gray48: "#6a6a6a",
        Gray49: "#e9e9e9",
        Blue6: "#444352",
        GrayBlack: "#343434",
        GrayBlack1: "#444444",
        Green5: "#86b820",
        Blue7: "#3c90d4",
        Gray51: "#787780",
        Gray52: "#bfbfbf",
        Red5: "#d0021b",
        Gray53: "#d6d6d6",
        Blue8: "#f0f7ff",
        Blue9: "#0086cd",
        Gray54: "#8a8a8c",
        Green6: "#65CA99",
        Green7: "#7ca91e",
        Red3: "#f45353",
        Red4: "#ff6262",
        Gray55: "#e6f5ff",
        Blue10: "#2c97e",
        Gray59: "#919191",
        BlackLight: "#464646",
        Gray60: "#898989",
        Yellow: "#f7d76a",
        Yellow11: "#f3c22c",
        Gray57: "#807f7d",
        Gray58: "#aaa",
        Gray50: "#8a8a8c",
        Gray64: "#a1a1a1",
        Gray56: "#dfdfdf",
        White2: "#9d9d9d",
        Gray61: "#fafafa",
        Gray62: "#d3d3d3",
        Green8: "#4abc90",
        Gray63: "#5b5b5b",
        Gray68: "#d1d1d1",
        Blue12: "#3e97eb",
        LightPink: "#fdf5f4",
        LightRed: "#f4aba2",
        Gray65: "#c4c4c4",
        Gray66: "#b5b5b5",
        Gray67: "#e0dfe0",
        Blue11: "#1976d2",
        Gray69: "#969696",
        White3: "#efefef",
        facebook: "#3A559F",
        twitter: "#03A9F4",
        Green9: "#87b820",
        Gray70: "#c8c8c8",
        Gray71: "#fcfcfc",
        Gray72: "#3a91cd",
        Gray74: "#ececec",
        Blue15: "#224d6f",
        Green10: "#c3d49d",
        Blue16: "#a8e1f7",
        Blue19: "#3b6eff",
        Blue18: "#049ae5",
        Gray73: "#f8f9fb",
        Blue17: "#4267b2",
        LightBlue1: "#78cdf0",
        Green11: "#6ab835",
        Black8: "#323050",
        SeaGreen: "#47c1c1",
        Gray75: "#646464",
        Gray76: "#d0d0d0",
        Gray77: "#808080",
        Gray78: "#656565",
        Gray79: "#adb1b3",
        Gray80: "#cfcfcf",
        Blue20: "#73b6ff",
        Blue21A: "#93c9ff",
        Blue22: "#a1c0e4",
        GrayLightFive: "#ededed",
        GrayLightSix: "#f3f3f3",
        Yellow1: "#f5a623",
        Red7: "#ff3951",
        Red8: "#B00020",
        Blue23: "#0e91f9",
        Yellow2: "#ffc108",
        Black1A: "#2a2a2a",
        Blue24: "#4090d2",
        Blue25: "#008eff",
        Blue26: "#4a90e2",
        GrayLight1: "#bec4cb",
        GrayLight2: "#b3b3b3",
        GrayLightBorder: "#b0d27d",
        GrayLightBorder2: "#5e8226",
        BackgroundBlue: "#039be5",
        GrayBackground: "#d3d4d5",
        GrayIconFill: "#9f9f9f",
        BlueIconFill: "#0076ff",
        OrangeBackground: "#f49c15",
        White4: "#e2e2e2",
        White5: "#f9f9f9",
        Orange4: "#e1900f",
        Orange5: "#eb9a58",
        Gray81: "#f8f8fb",
        BorderGray: "#d6d1d1",
        Gray80A: "#9e9e9e",
        GrayBorder1: "#d8d9db",
        Bluebackground: "#034081",
        Gray_79: "#cbcbcb",
        InputGray: "#b9b9b9",
        BackgroundGray1: "#565656",
        SliderBackground: "#cdcdcdbf",
        RedAsterisk: "#FF0000",
        TableBackground: " #e7ebf0",
        GrayBorder: "#0000008a",
        GrayBorder2: "#000000de",
        GrayColor: "#282828",
        GrayColor1: "#fefaf5",
        GrayInput: "#00000099",
        BlueFocus: "#0072e5",
        Gray100A: "#dddddd",
        DarkGray5: "#616161",
        Graydark1: "#d7d7d7",
        MuiBorderColor: "#0000006b",
        BlueLight1: "#ade1f5",
        GrayDisabled: "#C5C5C5",
        GrayLabel: "#7a7a7a",
        GrayBackground4: "#00000066",
        DarkGray22: "#5d5d5d",
        Green12: "#84a930",
        Green13: "#85b61d",
        BlueBorder: "#002c50",
        inputFieldGray: "#979592",
        headingGray: "#171915",
        Gray82: "#dadada",
        BorderGray2: "#c6c6c6",
        //openSooq colors-standard
        Grey: "#F2F2F7",
        Orange: "#f39c12",
        Offline: "#d0d0d0",
        Premium: "#ffa001",
        Shop: "#65ca99",
        Bundles: "#f1be48",
        Elas: "#204b70",
        Turbo: "#ff3951",
        Credit: "#6577ca",
        Bumpup: "#0e91f9",
        Gold: "#edba1d",
        Silver: "#a7a9ac",
        WABg: "#67d561",
        LabelGray: "#848484",
        LightGrayBorder: "#f8f8f8",
        LightGray2: "#dcdcdc",
        Blue27: "#4091d2",
        GrayLight5: "#fbfbfb",
        Gray101A: "#f4f1f8",
        Black10A: "#3f3f3f",
        GraySubLabel: "#8A8A8A",
        GrayDark2: "#686b80",
        Black11A: "#737373",
        Blue10A: "#adadb0",
        Orange6A: "#ff6900",
        NavyBlue5A: "#002c50",
        BlackA10: "#171915",
        Gray90: "#9a9a9a",
        Gray91: "#818181",
        Gray92: "#78909c",
        Gray93: "#37474f",
        babyBlue: "#d0eafd",
        Gray94: "#808083",
        SkyBlue1: "#f5faff",
        Black20A: "#000b33",
        yellow: "#FECE00",
    },

    fonts: {
        HelveticaNeue: "HelveticaNeue",
        HelveticaNeueBold: "HelveticaNeueBold",
        HelveticaNeueSKY: "HelveticaNeueSKY",
        HelveticaNeueW23forSKYBd: "HelveticaNeueSKYBold",
        Helvetica: "Helvetica",
        SFArabic: "SFArabic",
    },
};

export const updateThemeMemberData = (data: IMember) => {
    defaultTheme.memberData = data;
};

export default defaultTheme;
